/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */

import React, { useContext, useEffect, useState } from 'react'

import { listAttachments } from '../../assets/ts/data/files/files'
import {
  LIST_NAME,
  SiteFeedback,
  addOrUpdateSiteFeedBack,
} from '../../assets/ts/data/site-feedback'
import { isDropDownValid, isInputValid } from '../../assets/ts/validations/validations'
import { MetadataContext } from '../../store/metadata-context-provider'
import { PreviousPageContext } from '../../store/previous-page-provider'
import { RoleContext } from '../../store/role-context-provider'
import { UserContext } from '../../store/user-context-provider'
import { SELECT_OPTION_STRING } from '../../utils/constants/global-constants'
import CustomSelect from '../../utils/controls/custom-select'
import InputText from '../../utils/controls/input-text'
import InputTextArea from '../../utils/controls/input-text-area'
import Buttons from '../buttons/buttons'
import FileUpload from '../file-upload/file-upload'
import PageOverlayBusy from '../page-overlay/page-overlay-busy'
import './feedback.css'

export default function Feedback() {
  
  const { sections } = useContext(MetadataContext)
  const { me } = useContext(UserContext)
  const {userGroups } = useContext(RoleContext)
  const { currentPage, setCurrentPage, setPreviousPage } =  useContext(PreviousPageContext)

  const validation = {
    about: true,
    message: true,
    subject: true,
  }

  const [siteFeedbackValidations, setSiteFeedbackValidations] = useState(validation)
  const [piiScan, setPIIScan] = useState<any>({})
  
  const [files, setFiles] = useState<any>([])

  const [feedbackAbout, setFeedbackAbout] = useState<any>('Select')
  const [message, setMessage] = useState('')
  const [subject, setSubject] = useState('')
  
  const [clearFiles, setClearFiles] = useState<boolean>(false)
  const [displayPII, setDisplayPII] = useState(false)
  const [fileError, setFileError] = useState(false)
  const [replaceFile, setReplaceFile] = useState(false)
  const [showPageOverlay, setPageOverlay] = useState(false)
  const [showSuccessMessage, setShowSuccessMessage] = useState<boolean>(false)

  const feedbackAboutOptions = [
    SELECT_OPTION_STRING,
    ...sections.map(({ Section }) => ({
      label: Section,
      value: Section,
    })),
  ]

  const resetSiteFeedbackForm = () => {
    setSubject('')
    setMessage('')
    setFiles([])
    setClearFiles(!clearFiles)
    setFeedbackAbout('')
    setPIIScan({})
    setSiteFeedbackValidations(validation)
  }
  
  const checkValidation = (): boolean => {
    const isSubjectValid = isInputValid(subject)
    const isFeedBackAboutValid = isDropDownValid(feedbackAbout)
    const isMessageValid = isInputValid(message)
    setSiteFeedbackValidations({
      about: isFeedBackAboutValid,
      message: isMessageValid,
      subject: isSubjectValid,
    })
    return isSubjectValid && isFeedBackAboutValid && isMessageValid
  }
  const onSubmit = async () => {
    const isValid = checkValidation()
    if (isValid) {
      setPageOverlay(true)
      const feedbackObj: SiteFeedback = {
        Description: message,
        FeedbackAbout: feedbackAbout,
        ItemCreated: new Date(),
        ItemCreatedBy: me.rid,
        ItemModified: new Date(),
        ItemModifiedBy: me.rid,
        Title: subject,
        UserRole: userGroups.length > 0 ? userGroups[0] : 'Customer',
      }
      try {
        const addedFeedBack = await addOrUpdateSiteFeedBack(feedbackObj)
        if (files?.length > 0) {
          const promises: Promise<void>[] = []
          promises.push(listAttachments(LIST_NAME, addedFeedBack?.eKey as string, files))
          Promise.all(promises)
            .then(function () {
              setShowSuccessMessage(true)
              resetSiteFeedbackForm()
              setPageOverlay(false)
            })
            .catch(function (error) {
              console.error(error)
            })
        } else {
          setShowSuccessMessage(true)
          resetSiteFeedbackForm()
          setPageOverlay(false)
        }
      } catch (error) {
        console.error('Error while adding or updating site feedback:', error)
      }
    }
  }

  const handleRef = (ref: HTMLParagraphElement | null) => {
    const messageRef = ref
    if (messageRef) {
      messageRef.focus()
    }
  }

  useEffect(() => {
    // This effect runs whenever the location changes (when the user navigates to a different route)
    if (currentPage !== location.pathname) {
      // User has navigated to a new page, so update the previous page
      setPreviousPage(currentPage) // Store the previous page
      setCurrentPage(location.pathname) // Update the current page
    }
  }, [location, currentPage]) // Runs whenever location or currentPage changes
  return (
    <>
      {showSuccessMessage && (
        <div
          className='buttonPopups border-color3 medium-popup sitefeedbackpopup'
          style={{ padding: '15px', position: 'absolute', top: '10', zIndex: '9999' }}
        >
          <div
            aria-label='Thank you for your time, your feedback has been recorded.'
            className='sucessfeedback'
            ref={handleRef}
            tabIndex={0}
          >
            <span className='hintmsg w-100 pt-1 text-color1'>
              {' '}
              Thank you for your time, your feedback has been recorded.
            </span>
            <span
              aria-label='Close'
              className='icon-close text-color1'
              onClick={() => setShowSuccessMessage(false)}
              tabIndex={0}
              title='Close'
            ></span>
          </div>
        </div>
      )}
      {showPageOverlay && <PageOverlayBusy />}

      <div className='shadow card card-body max-w-700 col-12 col-lg-8 col-xxl-5'>
        <h3>Site Feedback</h3>
        <div className='subtitle-color font-9 montserratregular'>
          Please let us know how we can make this site more useful to you
        </div>
        <div className='feedback-body'>
          <div className='pt-2'>
            <InputText
              changeHandler={(event: { target: { value: React.SetStateAction<string> } }) =>
                setSubject(event.target.value)
              }
              className='form-sm'
              error={!siteFeedbackValidations.subject}
              formClassName='ms-auto form-vertical'
              info='subject '
              infoClassName='tool-tip tooltip-bottom-left font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: 'font-12',
                id: 'subject',
                maxLength: 255,
                name: 'Subject',
                placeholder: 'Subject',
                value: subject,
              }}
              isInfo
              isMandatory
              label='Subject'
            />
          </div>
          <div className='pt-2'>
            <CustomSelect
              className='form-sm customselect'
              error={!siteFeedbackValidations.about}
              formClassName='form-vertical'
              id='feedbackabout '
              info='feedbackabout'
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              isInfo
              isMandatory
              label='Feedback About'
              name={'Feedback About'}
              onChange={(e: any) => {
                setFeedbackAbout(e.value)
              }}
              options={feedbackAboutOptions}
              value={feedbackAbout}
            />
          </div>
          <div className='pt-2'>
            <FileUpload
              clearFiles={clearFiles}
              filesProps={{ files, setFiles }}
              formClassName='d-flex flex-column'
              hint='Upload the files which are in the .png, .jpeg, .xlsx, .txt .docx, .pdf files and special characters will not be used in the document names. Maximum size for file is 25 MB. Limit is up to 10 files per screen'
              hintClassName='color-primary'
              info='Attach File(s) '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info'
              inputProps={{
                className: '',
                id: 'attachfiles',
                name: 'Description',
              }}
              isInfo
              label='Attach File(s)  '
              note='Screenshots need to be saved locally before uploading into system.'
              noteClassName='color-primary'
              replaceFileProps={{replaceFile, setReplaceFile}}
              setFileError={setFileError}
            />
          </div>
          <div className='pt-2'>
            <InputTextArea
              className='h-auto'
              error={!siteFeedbackValidations.message}
              formClassName='ms-auto form-vertical'
              info='message '
              infoClassName='tool-tip tooltip-top font-12 sourcesanspro'
              infoIcon='icon-info color-primary'
              inputProps={{
                className: '',
                id: 'message',
                name: 'Message',
                placeholder: 'Message',
                value: message,
              }}
              isInfo
              isMandatory
              label='Message'
              onChange={(event: { target: { value: React.SetStateAction<string> } }) =>
                setMessage(event.target.value)
              }
              rows='5'
            />
            <p>Click Submit to send us your feedback </p>
          </div>
        </div>
        <div className='pt-2 d-flex gap-2'>
          <Buttons
            aria-label='Submit'
            className='btn btn-sm btn-primary whitetext font-14 btn-border-radius3 ms-auto text-uppercase '
            icon='icon-checked font-12 me-1'
            id='submitButton'
            label='Submit'
            onClick={() => {
              onSubmit()
            }}
          />
          <Buttons
            className='btn-border1 darktext btn-sm font-14 btn-border-radius3 text-uppercase'
            icon='icon-close font-10 me-1 color-primary'
            label='Clear'
            name='Clear'
            onClick={() => {
              resetSiteFeedbackForm()
            }}
            type='button'
          />
        </div>
      </div>
    </>
  )
}
